import axios from "axios";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Table } from "reactstrap";
import { ServiceThreadSpinner, SortHeader } from ".";
import { api, constants, dateHelpers } from "../utils";

export default function InventoryDashBoardTransfersGrid(props) {
   const {
      selectedItem,
      typeOfDataSource,
      invTraSortField,
      invTraSortDirection,
   } = props.params;

   const [data, setData] = useState([]);
   const [loaded, setLoaded] = useState(false);
   const [params, setParams] = useState({});
   const payload = {
      ItemNumber: selectedItem?.value,
      TypeOfSource: typeOfDataSource,
      InvTraSortField: invTraSortField,
      InvTraSortDirection: invTraSortDirection,
   }

   useEffect(() => {
      const cancelToken = axios.CancelToken;
      const source = cancelToken.source();

      if (props.params.selectedItem?.value !== params.selectedItem?.value) {
         setParams(props.params)
         setLoaded(false); //for the spinner
      }
      api
         .postS('Inventory/InventoryTransfers', payload, source.token)
         .then(response => {
            if (response.data.success) {
               const dataResponse = response.data.itemGrid.inventoryTransfers
               setData(dataResponse);
               //set total here if its there
            } else {
               throw new Error(response);
            }
         })
         .catch(api.catchHandler)
         .finally(() => setLoaded(true));


      return () => {
         source.cancel("axios request cancelled");
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.params])

   return (
      <>
         <Card className="dashboard-card">
            <CardBody>
               <div>
                  <span className="h2 me-2">Recent Inventory Transfers Last 120 Days</span>
               </div>
               <hr />
               <ServiceThreadSpinner on={!loaded}>
                  {loaded && data.length !== 0 ?
                     <Table size="sm" className="data-table">
                        <thead className="table-header">
                           <tr>
                              <th style={{ width: "10%" }}>
                                 <SortHeader
                                    displayName={"Date"}
                                    field={"TransferDate"}
                                    sortDirection={props.sortDirection}
                                    sorted={props.sortField === "TransferDate"}
                                    callback={props.sortCallback}
                                    state={{
                                       invTraSortField: "TransferDate",
                                       invTraSortDirection: props.sortDirection === "asc" ? "desc" : "asc",
                                       typeOfDataSource: constants.INVENTORYDASHBOARD_TYPES.InventoryTransfers,
                                    }}
                                 />
                              </th>
                              <th style={{ width: "10%" }}>
                                 <SortHeader
                                    displayName={"From"}
                                    field={"TransactionLocation"}
                                    sortDirection={props.sortDirection}
                                    sorted={props.sortField === "TransactionLocation"}
                                    callback={props.sortCallback}
                                    state={{
                                       invTraSortField: "TransactionLocation",
                                       invTraSortDirection: props.sortDirection === "asc" ? "desc" : "asc",
                                       typeOfDataSource: constants.INVENTORYDASHBOARD_TYPES.InventoryTransfers,
                                    }}
                                 />
                              </th>
                              <th style={{ width: "10%" }}>
                                 <SortHeader
                                    displayName={"To"}
                                    field={"TransferToSite"}
                                    sortDirection={props.sortDirection}
                                    sorted={props.sortField === "TransferToSite"}
                                    callback={props.sortCallback}
                                    state={{
                                       invTraSortField: "TransferToSite",
                                       invTraSortDirection: props.sortDirection === "asc" ? "desc" : "asc",
                                       typeOfDataSource: constants.INVENTORYDASHBOARD_TYPES.InventoryTransfers,
                                    }}
                                 />
                              </th>
                              <th style={{ width: "10%" }}>
                                 <SortHeader
                                    displayName={"Quantity"}
                                    field={"TransactionQty"}
                                    sortDirection={props.sortDirection}
                                    sorted={props.sortField === "TransactionQty"}
                                    callback={props.sortCallback}
                                    state={{
                                       invTraSortField: "TransactionQty",
                                       invTraSortDirection: props.sortDirection === "asc" ? "desc" : "asc",
                                       typeOfDataSource: constants.INVENTORYDASHBOARD_TYPES.InventoryTransfers,
                                    }}
                                 />
                              </th>
                           </tr>
                        </thead>
                        <tbody>
                           {_.map(data, (datum, index) => {
                              return (
                                 <tr key={index} className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}>
                                    <td className="data-cell" children={dateHelpers.toLongDateString(datum.transferDate)} />
                                    <td className="data-cell" children={datum.transactionLocation} />
                                    <td className="data-cell" children={datum.transferToSite} />
                                    <td className="data-cell" children={Math.round(datum.transactionQty).toLocaleString()} />
                                 </tr>
                              );
                           })}
                        </tbody>
                     </Table>
                     :
                     <div>
                        <span>No inventory transfers found for the period</span>
                     </div>
                  }
               </ServiceThreadSpinner>
            </CardBody>
         </Card>
      </>
   );
}
